import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
const carouselContainerClassesMap = {
    comparison: 'flex gap-m duration-1000',
    tariff: 'flex gap-5xl flex-grow duration-1000',
};
export const TableCarouselContainer = JSX(({ children, activeIndex, columnWidth, version = 'comparison' }) => (_jsx("div", { className: "flex flex-1 overflow-hidden", children: _jsx("div", { className: carouselContainerClassesMap[version], style: { transform: `translateX(-${activeIndex * columnWidth}px)` }, children: children }) })));
//# sourceMappingURL=TableCarouselContainer.js.map